import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingConceptType,
    getConceptTypeById,
    saveConceptType,
    updateConceptType,
    deleteConceptType,
    getAllConceptType
} from 'app/services/ConceptTypeService';

import { ConceptType } from "app/common/Model/ConceptType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import i18n from 'i18n';

export default class ConceptTypeStore {
    listAllConceptType = [];
    searchConceptType = new SearchObject();
    pageConceptType = null;
    selectedConceptType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteConceptType = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllConceptType = async () => {
        if(this.listAllConceptType?.length) return;
        const searchObjectForAll = {
            pageIndex: 1,
            pageSize: 1000000,
        };
        return await getAllConceptType()
            .then(({ data }) => {
                this.listAllConceptType = data;
            }).
            catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu loại khái niệm có lỗi");
            })
    }

    pagingConceptType = async () => {
        return await pagingConceptType(this.searchConceptType)
            .then(({ data }) => {
                this.pageConceptType = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu loại khái niệm có lỗi");
            })
    }

    handleChangeFormSearch = (searchConceptType) => {
        this.searchConceptType = checkSearchObject(this.searchConceptType, searchConceptType);
        this.pagingConceptType();
    }

    handleOpenFormCreateOrEdit = (conceptTypeId) => {
        if (Boolean(conceptTypeId)) {
            getConceptTypeById(conceptTypeId)
                .then(({ data }) => {
                    this.selectedConceptType = data;
                    this.openFormCreateOrEdit = true;
                }).catch(function (error) {
                    console.error(error);
                    toast.error(i18n.t("management.conceptType.getDataFail"));
                });
        } else {
            this.selectedConceptType = new ConceptType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveConceptType = async (conceptType, { setSubmitting }) => {
        return await saveConceptType(conceptType).then(() => {
            this.selectedConceptType = null;
            toast.success(i18n.t("management.conceptType.saveSuccess"));
            this.pagingConceptType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.conceptType.saveFail"));
        }).finally(function () {
            setSubmitting(false);
        });
    }

    updateConceptType = async (conceptType, { setSubmitting }) => {
        return await updateConceptType(conceptType).then(() => {
            this.selectedConceptType = null;
            toast.success(i18n.t("management.conceptType.updateSuccess"));
            this.pagingConceptType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.conceptType.updateFail"));
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteConceptType = (conceptType) => {
        this.selectedConceptType = { id: conceptType?.id };
        this.openConfirmDeleteConceptType = true;
    }

    handleConfirmDeleteConceptType = () => deleteConceptType(this.selectedConceptType?.id)
        .then(() => {
            if (this.searchConceptType.pageIndex > 1 && this.pageConceptType?.content?.length === 1) {
                this.searchConceptType.pageIndex -= 1;
            }
            toast.success(i18n.t("management.conceptType.deleteSuccess"));
            this.pagingConceptType();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.conceptType.deleteFail"));
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptType = false;
    }

    resetStore = () => {
        this.searchConceptType = new SearchObject();
        this.pageConceptType = null;
        this.selectedConceptType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteConceptType = false;
    }
}